import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSystemSettings } from '../lib/SystemSettingsContext';

interface RouteGuardProps {
  children: ReactNode;
  checkSetting: 'disableLogin' | 'disableSignup' | 'disableAI' | 'disablePentestOrchestrator' | 'disableStraightUpMethodologies' | 'disableGuidedMethodologies' | 'disablePathway' | 'disableHuntersBoard';
  redirectTo?: string;
}

/**
 * A component that protects routes based on system settings
 * If the specified setting is enabled (true), the user will be redirected
 */
const RouteGuard: React.FC<RouteGuardProps> = ({ 
  children, 
  checkSetting,
  redirectTo = '/dashboard'
}) => {
  const { settings } = useSystemSettings();
  
  // If the setting is enabled (e.g., disableAI = true), redirect to the specified path
  if (settings[checkSetting]) {
    return <Navigate to={redirectTo} replace />;
  }
  
  // Otherwise, render the children
  return <>{children}</>;
};

export default RouteGuard; 